// extracted by mini-css-extract-plugin
module.exports = {"lottie-view":"LottieView_lottie-view__uDVTv","lottieView":"LottieView_lottie-view__uDVTv"};